export interface AppRoute {
    path: string;
    label: string;
    exIcon: string;
}

export const appRoutes: AppRoute[] = [
    {
        path: 'home',
        label: 'Home',
        exIcon: 'Home',
    },
    {
        path: 'connections',
        label: 'Configs',
        exIcon: 'shield',
    },
    {
        path: 'identity-providers',
        label: 'Identity Providers',
        exIcon: 'Identity providers',
    },
];
